<div class="invoice-detail-container" *ngIf="invoiceDetailForm">
  <form [formGroup]="invoiceDetailForm" class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">

    <div class="innertitletxt">
      Détail de la facture :
    </div>

    <div class="card">
      <div class="card-body">

        <div fxLayout="column">

          <!-- Case à cocher : Facture directe "vs" Situation -->
          <div style="margin-bottom: 10px" fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" *ngIf="shouldShowCheckCreateInPPR()">
            <div fxFlex="50" fxLayoutGap="10px">
              <div fxFlex="50">
                <mat-checkbox formControlName="IsForPPRDirectInvoiceBDC" (change)="onChangeCheckBDC($event)">Facture
                  directe / Facture avec BDC</mat-checkbox>
              </div>
              <div appearance="outline" fxFlex="50">
                <mat-checkbox formControlName="IsWorkingSituation" (change)="onChangeCheckSituation($event)">Situation /
                  Note d'honoraires</mat-checkbox>
              </div>
            </div>
            <div fxFlex="50">
            </div>
          </div>

          <!-- Type de Rejet / Prise en charge par /Date de prise en charge -->
          <ng-container *ngIf="invoiceParams.isRejectedInvoice">
            <ng-container *ngTemplateOutlet="TemplateRejectedInvoiceInformation"></ng-container>
          </ng-container>

          <hr class="separator" *ngIf="invoiceParams.isRejectedInvoice">

          <!-- Mise en litige -->
          <ng-container *ngIf="isComplaintInvoice">
            <ng-container *ngTemplateOutlet="TemplateComplaintInvoiceInformation"></ng-container>
          </ng-container>

          <hr class="separator" *ngIf="isComplaintInvoice">

          <!-- Facture n° / Societe metadonnées -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <ng-container *ngIf="(canChangeNumber || (invoiceParams.isDuplicateInvoice && this.invoiceParams.isRejectedInvoice))">
              <div fxFlex="50" fxLayoutGap="10px">
                <div fxFlex="50">
                  <ng-container *ngTemplateOutlet="TemplateinvoiceNumberEditNew"></ng-container>
                </div>
                <div fxFlex="50">
                  <ng-container *ngTemplateOutlet="TemplateAssignmentGroupName"></ng-container>
                </div>
              </div>
              <div fxFlex="50" *ngIf="invoiceParams.isManual"></div>
              <div fxFlex="50" *ngIf="!invoiceParams.isManual">
                <ng-container *ngTemplateOutlet="TemplatesupplierRecipientNameNew"></ng-container>
              </div>
            </ng-container>
            <ng-container *ngIf="!(canChangeNumber || (invoiceParams.isDuplicateInvoice && this.invoiceParams.isRejectedInvoice))">
              <div fxFlex="50" fxLayoutGap="10px">
                <div fxFlex="50" *ngIf="shouldShowCheckCreateInPPR()">
                  <ng-container *ngTemplateOutlet="TemplateinvoiceNumberReWrite"></ng-container>
                </div>
                <div fxFlex="50" *ngIf="!shouldShowCheckCreateInPPR()">
                  <ng-container *ngTemplateOutlet="TemplateinvoiceNumberReadOnlyNew"></ng-container>
                </div>
                <div fxFlex="50">
                  <ng-container *ngTemplateOutlet="TemplateAssignmentGroupName"></ng-container>
                </div>
              </div>
              <div fxFlex="50" *ngIf="invoiceParams.isManual"></div>
              <div fxFlex="50" *ngIf="!invoiceParams.isManual">
                <ng-container *ngTemplateOutlet="TemplatesupplierRecipientNameNew"></ng-container>
              </div>
            </ng-container>

          </div>


          <!-- Siret / Siren / Société -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateSocieteSIRENSIRET"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50" class="dropDownStyle">
              <ng-container *ngTemplateOutlet="TemplateSociete"></ng-container>
            </div>
          </div>

          <!-- Raison sociale / Référence 1 / Référence 2 -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateRaisonSocialeEvalua"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px" *ngIf="shouldShowDirectOrBDC || shouldShowSituation">
              <ng-container *ngTemplateOutlet="TemplateSupplierOperation"></ng-container>
            </div>
          </div>

          <!-- Raison sociale eValua / Code ERP Sage / Groupe d'affectation -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateRaisonSociale"></ng-container>
            </div>
            <div fxFlex="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateInvoiceReferences"></ng-container>
            </div>
          </div>

          <!-- Tiers Payeur / Code de l'opération / Nom de l'opération -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" *ngIf="shouldShowDirectOrBDC || shouldShowSituation">
            <div fxFlex="50" fxFlex.gt-sm="50" [ngClass]="invoiceDetailForm.controls['ThirdPartyPayerName'].disabled ? '' : 'dropDownStyle'">
              <ng-container *ngTemplateOutlet="TemplateTiersPayeur"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50">
            </div>
          </div>

          <!-- RCS / TVA Intra / Numéro de bon de commande / Type de facture / commentaire -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateRCSTVAIntra"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50" *ngIf="showLastForwardComment">
              <ng-container *ngTemplateOutlet="TemplateLastForwardComment"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px" *ngIf="shouldShowDirectOrBDC || shouldShowSituation">
              <ng-container *ngTemplateOutlet="TemplateOperationsInformation"></ng-container>
            </div>
            <div fxFlex="50" *ngIf="invoiceDetailModel.IsVoucher && invoiceDetailModel.IsProcessed">
              <ng-container *ngTemplateOutlet="TemplateVoucherDepartment"></ng-container>
            </div>
          </div>

          <!-- Date facture / Date échéance -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutAlign="space-between start" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateDateInformations"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px" *ngIf="shouldShowDirectOrBDC">
              <ng-container *ngTemplateOutlet="TemplateCommandeTypeFacture"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px" *ngIf="shouldShowSituation">
              <ng-container *ngTemplateOutlet="TemplateLotsInformation"></ng-container>
            </div>
            <div fxFlex="50" *ngIf="invoiceDetailModel.IsVoucher && invoiceDetailModel.IsProcessed">
              <ng-container *ngTemplateOutlet="TemplateVoucherAnalyticalSection"></ng-container>
            </div>
          </div>

          <!-- Montant HT / Montant TTC / Devise / Reverse Factoring -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxLayoutGap="10px">
              <div fxFlex="50" fxLayoutGap="10px" *ngIf="! shouldShowDirectOrBDC && ! shouldShowSituation">
                <ng-container *ngTemplateOutlet="TemplateInvoiceAmount"></ng-container>
              </div>
              <div fxFlex="50" fxLayoutGap="10px">
                <ng-container *ngTemplateOutlet="TemplateInvoiceAmountSecondPart"></ng-container>
              </div>
              <div fxFlex="50" *ngIf="this.invoiceParams.isPrescriptorGroup && shouldShowDirectOrBDC">
                <ng-container *ngTemplateOutlet="TemplateInvoiceEstimatedActDate"></ng-container>
              </div>
            </div>
            <div fxFlex="50" fxLayoutGap="10px" *ngIf="shouldShowDirectOrBDC">
              <ng-container *ngTemplateOutlet="TemplateInvoicePPRType"></ng-container>
            </div>
            <div fxFlex="50" fxLayoutGap="10px" *ngIf="shouldShowSituation">
              <ng-container *ngTemplateOutlet="TemplateSituationInformations"></ng-container>
            </div>
            <div fxFlex="50" *ngIf="invoiceDetailModel.IsVoucher && invoiceDetailModel.IsProcessed">
              <ng-container *ngTemplateOutlet="TemplateVoucherAnalyticalCode"></ng-container>
            </div>
          </div>

          <!-- Commentaire voucher-->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" *ngIf="invoiceDetailModel.IsVoucher && invoiceDetailModel.IsProcessed">
            <div fxFlex="50">
            </div>
            <div fxFlex="50">
              <ng-container *ngTemplateOutlet="TemplateVoucherComment"></ng-container>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div *ngIf="shouldShowDirectOrBDC">
      <app-invoice-expense #invoiceexpenses [invoiceDetailModel]="invoiceDetailModel" [invoiceDetailAmountCalc]="invoiceDetailAmountCalc" [invoiceDetailForm]="invoiceDetailForm"
        [dropDownSettingsExpenseFamilyType]="dropDownSettingsExpenseFamilyType" [dropDownDataExpenseFamilyType]="dropDownDataExpenseFamilyType" [dropDownSettingsVat]="dropDownSettingsVat"
        [dropDownDataVat]="dropDownDataVat" [invoiceParams]="invoiceParams" [isReadOnlyForm]="isReadOnlyForm" [isReadOnlyFormOrWaiting]="isReadOnlyFormOrWaiting" [submitted]="submitted"
        [editedDropdowns]="editedDropdowns" (onExpensesChange)="setExpensesChange($event)" (onExpensesPatched)="setExpensesChangePristine($event)">
      </app-invoice-expense>
    </div>

    <div class="card" *ngIf="shouldShowSituation">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="InvoiceAmountMarketBefore"></ng-container>
      </div>
    </div>

    <div *ngIf="shouldShowSituation">
      <app-invoice-amendment [invoiceDetailModel]="invoiceDetailModel" [invoiceDetailAmountCalc]="invoiceDetailAmountCalc" [invoiceDetailForm]="invoiceDetailForm" [dropDownDataVat]="dropDownDataVat"
        [dropDownDataAvenant]="dropDownDataAvenant" [dropDownSettingsAvenant]="dropDownSettingsAvenant" [invoiceParams]="invoiceParams" [isReadOnlyForm]="isReadOnlyForm"
        [isReadOnlyFormOrWaiting]="isReadOnlyFormOrWaiting" [submitted]="submitted" [editedDropdowns]="editedDropdowns" (onSetSumInvoiceTaxIncluded)="setSumInvoiceTaxIncluded()"
        (onAmendmentsChange)="setAmendmentsChange($event)" (onAmendmentsPatched)="setAmendmentsChangePristine($event)" (onAddOrDeleteAmendments)="setMandatoryFormField()">
      </app-invoice-amendment>
    </div>

    <div class="card" *ngIf="shouldShowSituation">
      <div class="card-body" *ngIf="shouldShowSituationWithAmendment">
        <ng-container *ngTemplateOutlet="InvoiceAmountMarketAfter"></ng-container>
      </div>
      <div class="card-body">
        <ng-container *ngTemplateOutlet="InvoiceTemplateSituationPreCalcul"></ng-container>
      </div>
    </div>

    <div *ngIf="shouldShowSituation">
      <app-invoice-deduction [invoiceDetailModel]="invoiceDetailModel" [invoiceDetailAmountCalc]="invoiceDetailAmountCalc" [invoiceDetailForm]="invoiceDetailForm"
        [dropDownSettingsDeductionType]="dropDownSettingsDeductionType" [dropDownDataDeductionType]="dropDownDataDeductionType" [dropDownDataDeductionTypeAll]="dropDownDataDeductionTypeAll"
        [selectedMarche]="selectedMarche" [invoiceParams]="invoiceParams" [isReadOnlyForm]="isReadOnlyForm" [isReadOnlyFormOrWaiting]="isReadOnlyFormOrWaiting" [submitted]="submitted"
        [editedDropdowns]="editedDropdowns" [invoiceViewType]="invoiceViewType" (onSetSumInvoiceTaxIncluded)="setSumInvoiceTaxIncluded()" (onDeductionsChange)="setDeductionsChange($event)"
        (onDeductionsPatched)="setDeductionsChangePristine($event)">
      </app-invoice-deduction>
    </div>

    <div *ngIf="shouldShowSituation">
      <app-invoice-delegation [invoiceDetailModel]="invoiceDetailModel" [invoiceDetailForm]="invoiceDetailForm" [dropDownSettingsDelegates]="dropDownSettingsDelegates"
        [dropDownSettingsCreditors]="dropDownSettingsCreditors" [delegates]="delegates" [creditors]="creditors" [selectedDelegations]="selectedDelegations" [invoiceParams]="invoiceParams"
        [isReadOnlyForm]="isReadOnlyForm" [isReadOnlyFormOrWaiting]="isReadOnlyFormOrWaiting" [editedDropdowns]="editedDropdowns" (filterChangeDelegates)="onFilterChangeDelegates($event)"
        (filterChangeCreditors)="onFilterChangeCreditors($event)" (onDelegationsChange)="setDelegationsChange($event)" (onDelegationsPatched)="setDelegationsChangePristine($event)">
      </app-invoice-delegation>
    </div>

    <div class="card" *ngIf="shouldShowSituation">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="InvoiceTemplateSituationFinalControl"></ng-container>
      </div>
    </div>

    <div class="card" *ngIf="invoiceDetailModel.ShouldBeChecked && invoiceParams.isDispatchedInvoice && invoiceDetailModel.Checked">
      <div class="card-body">
        <ng-container *ngTemplateOutlet="Templatecheck"></ng-container>
      </div>
    </div>

    <div *ngIf="invoiceParams.isPendingForWorkflowCompletionVoucher || invoiceParams.isPendingForVoucherValidation || invoiceParams.isPendingForWorkflowCompletionPromotion">
      <ng-container *ngTemplateOutlet="Templateworkflows"></ng-container>
    </div>


    <ng-template #Templatecheck>
      <div class="row">
        <div class="col-auto mr-auto">
          <div *ngIf="invoiceDetailModel.Checked">Contrôlée par <strong>{{invoiceDetailModel.CheckedByUser}} </strong>
            le
            <strong>{{invoiceDetailModel.CheckedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</strong>
          </div>
          <div *ngIf="!invoiceDetailModel.Checked">Cette facture n'a pas été contrôlée</div>
        </div>
        <div class="col-auto">
          <button *ngIf="invoiceDetailModel.Checked" mat-stroked-button class="currentBtnColor" matTooltip="Invalider le contrôle de la facture" (click)="uncheckInvoice()">
            <mat-icon>assignment_turned_in</mat-icon>
            <span fxHide fxShow.gt-md>Invalider le contrôle</span>
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #Templateworkflows>
      <app-invoice-traceability-workflows [InvoiceTraceability]="invoiceTraceability">
      </app-invoice-traceability-workflows>
    </ng-template>

    <ng-template #TemplateinvoiceNumberReadOnlyNew>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>FACTURE N°</mat-label>
        <input matInput value="{{ invoiceDetailModel.Number }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateinvoiceNumberReWrite>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>FACTURE N°</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.Number.dirty, formControls.Number.enabled) }" matInput formControlName="Number" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRejectedInvoiceInformation>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
        <div fxFlex="50" fxFlex.gt-sm="50">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>TYPE REJET</mat-label>
            <input matInput value="{{ invoiceDetailModel.RejectionFlag }}" type="text" readonly disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
            <mat-label>PRISE EN CHARGE PAR</mat-label>
            <input matInput value="{{ invoiceDetailModel.PickedByUser }}" type="text" readonly disabled>
          </mat-form-field>
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
            <mat-label>DATE DE PRISE EN CHARGE</mat-label>
            <input matInput value="{{ invoiceDetailModel.PickedAt | date:'dd/MM/yyyy HH:mm:ss' }}" type="text" readonly disabled>
          </mat-form-field>
        </div>
      </div>
    </ng-template>

    <ng-template #TemplateComplaintInvoiceInformation>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
        <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
            <mat-label *ngIf="!this.isReturnOperationalComment">MISE EN LITIGE PAR</mat-label>
            <mat-label *ngIf="this.isReturnOperationalComment">RETOUR A L'OPERATIONNEL PAR</mat-label>
            <input matInput value="{{ invoiceDetailModel.ComplaintByUser }}" type="text" readonly disabled>
          </mat-form-field>
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
            <mat-label *ngIf="!this.isReturnOperationalComment">DATE DE MISE EN LITIGE</mat-label>
            <mat-label *ngIf="this.isReturnOperationalComment">DATE DU RETOUR A L'OPERATIONNEL</mat-label>
            <input matInput value="{{ invoiceDetailModel.ComplaintAt | date:'dd/MM/yyyy HH:mm:ss' }}" type="text" readonly disabled>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.gt-sm="50">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label *ngIf="!this.isReturnOperationalComment">RAISON DU LITIGE</mat-label>
            <mat-label *ngIf="this.isReturnOperationalComment">RAISON DU RETOUR A L'OPERATIONNEL</mat-label>
            <input matInput value="{{ invoiceDetailModel.ComplaintComment }}" type="text" readonly disabled>
          </mat-form-field>
        </div>
      </div>
    </ng-template>

    <ng-template #TemplateinvoiceNumberEditNew>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>FACTURE N°</mat-label>
        <input matInput formControlName="Number" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplatesupplierRecipientNameNew>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>SOCI&Eacute;T&Eacute; M&Eacute;TADONN&Eacute;ES</mat-label>
        <input matInput value="{{ invoiceDetailModel.SupplierRecipientName }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRaisonSociale>
      <div [ngClass]="invoiceDetailForm.controls['SupplierEvaluaCompanyName'].disabled ? '' : 'dropDownStyle'" fxFlex="100" fxFlex.gt-sm="50">
        <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="invoiceDetailForm.controls['SupplierEvaluaCompanyName'].disabled">
          <mat-label>RAISON SOCIALE EVALUA
          </mat-label>
          <input matInput formControlName="SupplierEvaluaCompanyName" type="text" readonly>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="100" floatLabel="always" *ngIf="!invoiceDetailForm.controls['SupplierEvaluaCompanyName'].disabled">
          <mat-label>RAISON SOCIALE EVALUA
          </mat-label>
          <input matInput formControlName="SupplierEvaluaCompanyName" type="text" hidden>
          <ng-multiselect-dropdown [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('SupplierEvaluaCompanyName') , 'disabled': formControls['SupplierEvaluaCompanyName']?.disabled}"
            [formControl]="formControls['SupplierEvaluaCompanyName']" placeholder='Sélectionner' [settings]="dropDownSettingsSuppliers" [data]="suppliers"
            (onFilterChange)="onFilterChangeSupplier($event)" [ngModel]="invoiceDetailForm.controls.SupplierEvaluaCompanyName.value"
            (onSelect)="onChangeEvaluaCompany($event)" (onDeSelect)="onChangeEvaluaCompany(null)" ngDefaultControl>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25">
        <mat-label>SIRET EVALUA <i *ngIf="!invoiceParams.isRejectedInvoice && !invoiceParams.isInjection && !invoiceParams.canManageInvoiceAGI && !invoiceParams.isInvoiceForClient && !invoiceParams.isInvoiceForGroup">*</i>
        </mat-label>
        <input matInput value="{{ invoiceDetailModel.SupplierEvaluaSIRET }}" type="text" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25">
        <mat-label>CODE ERP SAGE <i *ngIf="!invoiceParams.isRejectedInvoice && !invoiceParams.isInjection && !invoiceParams.canManageInvoiceAGI && !invoiceParams.isInvoiceForClient && !invoiceParams.isInvoiceForGroup">*</i>
        </mat-label>
        <input matInput value="{{ invoiceDetailModel.SupplierSageErpCode }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRaisonSocialeEvalua>
      <mat-form-field floatLabel="always" appearance="outline" [fxFlex]="shouldShowDirectOrBDC ? '50' : (shouldShowSituation ? 75 : '100')">
        <mat-label>RAISON SOCIALE </mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.SupplierCompanyName.dirty, formControls.SupplierCompanyName.enabled) }" matInput formControlName="SupplierCompanyName" type="text">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" *ngIf="shouldShowDirectOrBDC || shouldShowSituation">
        <mat-label>N° TIERS GROUPE</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNotForGroup(formControls.GroupIdPPR.dirty, formControls.GroupIdPPR.enabled), 'text-transform': 'uppercase'
 }" matInput formControlName="GroupIdPPR" type="text"
          (change)="onChangeGroupIdPPR($event.target.value)" pattern="[AG][A-Z0-9]{5,6}" maxlength="7" minlength="6">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" *ngIf="shouldShowDirectOrBDC">
        <mat-label>N° TIERS CLIENT</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNotForClient(formControls.ClientIdPPR.dirty, formControls.ClientIdPPR.enabled) }" matInput formControlName="ClientIdPPR" type="text"
          (change)="onChangeClientIdPPR($event.target.value)" maxlength="7">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateInvoiceReferences>
      <div class="dropDownStyle" fxFlex="50">
        <mat-form-field floatLabel="always" floatLabel="always" appearance="outline" fxFlex="100">
          <mat-label> R&Eacute;F&Eacute;RENCE 1
          </mat-label>
          <input matInput formControlName="PrimaryReference" type="text" hidden>
          <div [fxFlex]="invoiceDetailModel.SupplierHasWarning ? 93 : 100">
            <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('PrimaryReference'), 'disabled': formControls['PrimaryReference']?.disabled }"
              (onFilterChange)="onAssetFilterChange($event)" [settings]="dropDownSettingsAssets" [data]="dropDownDataAssets"
              [formControl]="formControls['PrimaryReference']" [(ngModel)]="selectedAsset" (ngModelChange)="onAssetValueChange()" (onSelect)="onChangePrimaryReference($event)"
              (onDeSelect)="onChangePrimaryReference(null)" ngDefaultControl>
            </ng-multiselect-dropdown>
          </div>
          <div fxFlex="7" *ngIf="invoiceDetailModel.SupplierHasWarning" fxLayoutAlign="end center">
            <span tooltip="L'association Référence 1 et société n'est pas conforme" class="material-icons">
              error
            </span>
          </div>
        </mat-form-field>
      </div>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>R&Eacute;F&Eacute;RENCE 2</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.SecondaryReference.dirty, formControls.SecondaryReference.enabled) }" matInput formControlName="SecondaryReference" type="text"
          maxlength="100">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateSocieteSIRENSIRET>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>SIREN</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.SupplierSiren.dirty, formControls.SupplierSiren.enabled) }" matInput formControlName="SupplierSiren" type="text">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>SIRET</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.SupplierSiret.dirty, formControls.SupplierSiret.enabled) }" matInput formControlName="SupplierSiret" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateSociete>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
        <mat-label>SOCI&Eacute;T&Eacute; </mat-label>
        <input matInput formControlName="RecipientEntity" type="text" hidden>
        <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('RecipientEntity'), 'disabled': formControls['RecipientEntity']?.disabled }"
          (onFilterChange)="onRecipientEntityFilterChange($event)" [settings]="dropDownSettingsRecipientEntities" [data]="dropDownDataRecipientEntities"
          [formControl]="formControls['RecipientEntity']" [(ngModel)]="selectedRecipientEntity" (ngModelChange)="onRecipientEntityChange()"
          ngDefaultControl>
        </ng-multiselect-dropdown>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateSupplierOperation>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
        <mat-label>SOCIETE OPERATION </mat-label>
        <input matInput formControlName="OperationSocieteName" type="text" readonly>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRCSTVAIntra>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>RCS</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.SupplierRcsNumber.dirty, formControls.SupplierRcsNumber.enabled) }" matInput formControlName="SupplierRcsNumber" type="text">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>TVA INTRA <i *ngIf="!invoiceParams.isInjection && invoiceParams.isVatNumberComplianceEnabled">*</i>
        </mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.SupplierVatNumber.dirty, formControls.SupplierVatNumber.enabled) }" matInput formControlName="SupplierVatNumber" type="text">
      </mat-form-field>
    </ng-template>


    <ng-template #TemplateDateInformations>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50">
        <mat-label>DATE FACTURE </mat-label>
        <input matInput [matDatepicker]="dpIssue" formControlName="IssuedAt" placeholder="jj/mm/aaaa" (dateChange)="onChangeIssuedAt()" pattern="\d{1,2}/\d{1,2}/\d{4}">
        <mat-datepicker-toggle matSuffix [for]="dpIssue"></mat-datepicker-toggle>
        <mat-datepicker #dpIssue startView="month" panelClass="month-picker">
        </mat-datepicker>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50">
        <mat-label>DATE &Eacute;CH&Eacute;ANCE </mat-label>
        <input matInput [matDatepicker]="dpDue" formControlName="DueDate" placeholder="jj/mm/aaaa" pattern="\d{1,2}/\d{1,2}/\d{4}">
        <mat-datepicker-toggle matSuffix [for]="dpDue"></mat-datepicker-toggle>
        <mat-datepicker #dpDue startView="month" panelClass="month-picker">
        </mat-datepicker>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateCommandeTypeFacture>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="40" fxFlex.gt-sm="40" *ngIf="invoiceDetailForm.controls['CommandeInternalNumber'].disabled">
        <mat-label>NUM&Eacute;RO DU BDC <i *ngIf="invoiceParams.isBDCMandatory">*</i></mat-label>
        <input matInput formControlName="CommandeInternalNumber" type="text" readonly>
      </mat-form-field>
      <div class="dropDownStyle" *ngIf="! invoiceDetailForm.controls['CommandeInternalNumber'].disabled" fxFlex="75">
        <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
          <mat-label>NUM&Eacute;RO DU BDC <i *ngIf="invoiceParams.isBDCMandatory">*</i></mat-label>
          <input matInput formControlName="CommandeInternalNumber" type="text" hidden>
          <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'edited-color': editedDropdowns.includes('CommandeInternalNumber'), 'disabled': formControls['CommandeInternalNumber']?.disabled }" [settings]="dropDownSettingsCommandes"
            [data]="dataCommandes" formControlName="SelectedCommandeInternalNumber"
            [ngModel]="invoiceDetailForm.controls.SelectedCommandeInternalNumber.value" (onSelect)="onChangeCommande($event)" (onDeSelect)="onChangeCommande(null)" ngDefaultControl>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="40" fxFlex.gt-sm="40" *ngIf="invoiceDetailForm.controls['CommandeInternalNumber'].disabled">
        <mat-label>LIBELLE BDC <i *ngIf="invoiceParams.isBDCMandatory">*</i></mat-label>
        <a matTooltip="{{invoiceDetailInformationBDC.libelle}}">
          <input matInput value="{{invoiceDetailInformationBDC.libelle}}" type="text" readonly disabled>
        </a>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
        <mat-label>MONTANT HT BDC <i *ngIf="invoiceParams.isBDCMandatory">*</i></mat-label>
        <input matInput value="{{invoiceDetailInformationBDC.montantHT}}" type="text" readonly disabled decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateInvoicePPRType>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25" *ngIf="invoiceDetailForm.controls['InvoicePPRType'].disabled">
        <mat-label>TYPE DE FACTURE </mat-label>
        <input matInput formControlName="InvoicePPRTypeReadOnly" type="text" required readonly>
      </mat-form-field>
      <div class="dropDownStyle" *ngIf="! invoiceDetailForm.controls['InvoicePPRType'].disabled" fxFlex="25">
        <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
          <mat-label>TYPE DE FACTURE </mat-label>
          <input matInput formControlName="InvoicePPRType" type="text" hidden>
          <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('InvoicePPRType') }"
            [settings]="dropDownSettingsInvoicePPRType" [data]="dropDownDataInvoicePPRType" formControlName="InvoicePPRTypeLabel" [ngModel]="invoiceDetailForm.controls.InvoicePPRTypeLabel.value"
            (onSelect)="onChangeInvoicePPRType($event)" (onDeSelect)="onChangeInvoicePPRType(null)" ngDefaultControl>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>
    </ng-template>

    <ng-template #TemplateAssignmentGroupName>
      <mat-form-field *ngIf="!shouldShowCheckCreateInPPR() || shouldShowDirectOrBDC || shouldShowSituation" floatLabel="always" appearance="outline">
        <mat-label>GROUPE D'AFFECTATION</mat-label>
        <input matInput value="{{ invoiceDetailModel.CurrentAssignmentGroupName }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateTiersPayeur>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="invoiceDetailForm.controls['ThirdPartyPayerName'].disabled">
        <mat-label>TIERS PAYEUR</mat-label>
        <input matInput formControlName="ThirdPartyPayerName" type="text" readonly>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always" *ngIf="!invoiceDetailForm.controls['ThirdPartyPayerName'].disabled">
        <mat-label>TIERS PAYEUR</mat-label>
        <input matInput formControlName="ThirdPartyPayerName" type="text" hidden>
        <ng-multiselect-dropdown [ngClass]="{'edited-color': editedDropdowns.includes('ThirdPartyPayerName'), 'disabled': formControls['ThirdPartyPayerName']?.disabled}" formControlName="ThirdPartyPayerName" placeholder='Sélectionner'
          [settings]="dropDownSettingsThirdParty" [data]="thirdParty" onFilterChange="onFilterChangeThirdParty($event)"
          [ngModel]="invoiceDetailForm.controls.ThirdPartyPayerName.value" (onSelect)="onChangeThirdPartyPayer($event)" (onDeSelect)="onChangeThirdPartyPayer(null)" ngDefaultControl>
        </ng-multiselect-dropdown>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateOperationsInformation>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="30" *ngIf="invoiceDetailForm.controls['OperationId'].disabled">
        <mat-label>CODE DE L'OP&Eacute;RATION </mat-label>
        <input matInput formControlName="OperationId" type="text" required readonly>
      </mat-form-field>
      <div class="dropDownStyle" *ngIf="! invoiceDetailForm.controls['OperationId'].disabled" fxFlex="30">
        <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
          <mat-label>CODE DE L'OP&Eacute;RATION </mat-label>
          <input matInput formControlName="OperationId" type="text" hidden>
          <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('OperationId'), 'disabled': formControls['OperationId']?.disabled}"
            [settings]="dropDownSettingsOperations" [data]="dataOperations" (onFilterChange)="onFilterChangeOperation($event)"
            formControlName="OperationId" [ngModel]="invoiceDetailForm.controls.OperationId.value" (onSelect)="onChangeOperation($event)" (onDeSelect)="onChangeOperation(null)" ngDefaultControl>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="20">
        <mat-label>ENTIT&Eacute; COMPTABLE</mat-label>
        <input matInput formControlName="OperationEntiteComptable" type="text" readonly>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50">
        <mat-label>NOM DE L'OP&Eacute;RATION </mat-label>
        <input matInput formControlName="OperationName" type="text" readonly>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateLastForwardComment>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="showLastForwardComment">
        <mat-label>COMMENTAIRE</mat-label>
        <input matInput value="{{ lastForwardComment }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateLotsInformation>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" *ngIf="invoiceDetailForm.controls['TradeLabel'].disabled">
        <mat-label>CORPS DE M&Eacute;TIER </mat-label>
        <input matInput formControlName="TradeLabel" type="text" readonly disabled>
      </mat-form-field>
      <div class="dropDownStyle" fxFlex="50" *ngIf="! invoiceDetailForm.controls['TradeLabel'].disabled">
        <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
          <mat-label>CORPS DE M&Eacute;TIER </mat-label>
          <input matInput formControlName="TradeLabel" type="text" hidden>
          <ng-multiselect-dropdown placeholder='Sélectionner' [settings]="dropDownSettingsMarches" [data]="dataMarches" [disabled]="formControls['TradeLabel'].disabled" formControlName="TradeLabel"
            [ngModel]="invoiceDetailForm.controls.SelectedTrade.value" (onSelect)="onChangeMarche($event)" (onDeSelect)="onChangeMarche(null)" ngDefaultControl>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50">
        <mat-label>MONTANT DU MARCHE HT </mat-label>
        <input matInput formControlName="AmountTradeExcludingTax" type="text" readonly decimalFormat>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateSituationInformations>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="45">
        <mat-label>R&Eacute;F&Eacute;RENCE </mat-label>
        <input matInput formControlName="SituationReference" type="text" maxlength="50">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="30" appYearMonthFormat>
        <mat-label>P&Eacute;RIODE DE LA SITUATION </mat-label>
        <input matInput [matDatepicker]="dp" formControlName="SituationPeriode" placeholder="mm/yyyy" (dateChange)="setMonthAndYearManually()">
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)" panelClass="month-picker">
        </mat-datepicker>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="30" *ngIf="invoiceDetailForm.controls['VatCode'].disabled">
        <mat-label>% TVA </mat-label>
        <input matInput formControlName="VatReadOnly" type="text" readonly decimalFormat>
      </mat-form-field>
      <div class="dropDownStyle" *ngIf="!invoiceDetailForm.controls['VatCode'].disabled" fxFlex="25">
        <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
          <mat-label>% TVA </mat-label>
          <input matInput formControlName="VatCode" type="text" hidden>
          <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('VatCode')}"
            [settings]="dropDownSettingsVat" [data]="dropDownDataVat" [disabled]="formControls['VatCode'].disabled" formControlName="VatCode" [ngModel]="invoiceDetailForm.controls.SelectedVat.value"
            (onSelect)="onChangeVatForSituation($event)" (onDeSelect)="onChangeVatForSituation(null)" ngDefaultControl>
          </ng-multiselect-dropdown>
        </mat-form-field>
      </div>

    </ng-template>

    <ng-template #TemplateInvoiceAmount>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>MONTANT HT </mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.AmountTaxExcluded.dirty, formControls.AmountTaxExcluded.enabled) }" matInput formControlName="AmountTaxExcluded" type="text"
          decimalFormat pattern="^-?[0-9\s]+(?:[,.][0-9]{0,2})?$" step="0.01">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>MONTANT TTC </mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.AmountTaxIncluded.dirty, formControls.AmountTaxIncluded.enabled) }" matInput formControlName="AmountTaxIncluded" type="text"
          decimalFormat pattern="^-?[0-9\s]+(?:[,.][0-9]{0,2})?$" step="0.01">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateInvoiceAmountSecondPart>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="550">
        <mat-label>DEVISE</mat-label>
        <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.Currency.dirty, formControls.Currency.enabled) }" matInput formControlName="Currency" type="text">
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="505">
        <mat-label>REVERSE FACTORING</mat-label>
        <input matInput formControlName="IsReverseFactoring" type="text" hidden>
        <mat-slide-toggle color="primary" formControlName="IsReverseFactoring" name="IsReverseFactoring" class="customToggle">
        </mat-slide-toggle>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateInvoiceEstimatedActDate>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>DATE PR&Eacute;VISIONNELLE DE L'ACTE </mat-label>
        <input matInput [matDatepicker]="dp" formControlName="EstimatedActDate" placeholder="jj/mm/aaaa" pattern="\d{1,2}/\d{1,2}/\d{4}">
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="month" panelClass="month-picker">
        </mat-datepicker>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherDepartment>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>DIRECTION</mat-label>
        <input matInput formControlName="VoucherDepartment" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherAnalyticalSection>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>SELECTION ANALYTIQUE</mat-label>
        <input matInput formControlName="VoucherAnalyticalSection" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherAnalyticalCode>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>CODE PROJET</mat-label>
        <input matInput formControlName="VoucherAnalyticalCode" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherComment>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>COMMENTAIRE</mat-label>
        <textarea matInput formControlName="VoucherComment" type="text" placeholder="" rows="3" maxlength="250"></textarea>
      </mat-form-field>
    </ng-template>

    <ng-template #InvoiceAmountMarketBefore>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" class="no-wrapper">
        <div fxFlex="18" fxLayoutAlign="start center">
          <h2>TOTAL TRAVAUX</h2>
        </div>
        <div fxFlex="16" fxLayoutAlign="start center">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>RESTE À FACTURER HT </mat-label>
            <input matInput value="{{invoiceDetailModel.WorkSituationAmountTaxExcluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
              [style]="commonLibrary.getSumClass()">
          </mat-form-field>
        </div>
        <div fxFlex="22" fxLayoutAlign="start center">
        </div>
        <div fxFlex="14" fxFlex.gt-sm="14" class="special-margin-60" *ngIf="HasOneAmendments">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>MONTANT TRAVAUX HT </mat-label>
            <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.AmountTaxExcludedWithoutAmendment.dirty, formControls.AmountTaxExcludedWithoutAmendment.enabled) }" matInput
              formControlName="AmountTaxExcludedWithoutAmendment" type="text" decimalFormat pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01" (change)="setSumMarketWithAmendment()">
          </mat-form-field>
        </div>
      </div>
    </ng-template>

    <ng-template #InvoiceAmountMarketAfter>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" class="no-wrapper">
        <div fxFlex="56" fxLayoutAlign="start center">
        </div>
        <div fxFlex="14" fxFlex.gt-sm="14" class="special-margin-40">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>MONTANT HT </mat-label>
            <input matInput value="{{this.invoiceDetailAmountCalc.invoiceSumMarketWithAmendment}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
              [style]="commonLibrary.getSumClass()">
          </mat-form-field>
        </div>
      </div>
    </ng-template>

    <ng-template #InvoiceTemplateSituationPreCalcul>
      <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" class="no-wrapper">
        <div fxFlex="30" fxLayoutAlign="start center">
          <h2>TOTAL TRAVAUX + AVENANT</h2>
        </div>
        <div [fxFlex]="isAmountHTDifferent ? '20' : '26'" fxFlex.gt-sm="isAmountHTDifferent ? '20' : '26'">
          <div fxFlex="7" *ngIf="this.isCumulSituationChanged" fxLayoutAlign="end center">
            <span tooltip="Mise à jour par {{invoiceDetailModel.CumulationPreviousSituationSetByUser}} le {{ invoiceDetailModel.CumulationPreviousSituationSetAt | date:'dd/MM/yyyy HH:mm:ss' }}."
              class="material-icons">
              error
            </span>
          </div>
          <mat-form-field floatLabel="always" appearance="outline" [fxFlex]="this.isCumulSituationChanged ? 93 : 100" [fxFlex.gt-sm]="this.isCumulSituationChanged ? 93 : 100">
            <mat-label>CUMUL ANTERIEUR HT TRAVAUX + AVENANTS </mat-label>
            <div [fxFlex]="this.isCumulSituationChanged ? 93 : 100">
              <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.CumulationPreviousSituationAmountTaxExcluded.dirty, formControls.CumulationPreviousSituationAmountTaxExcluded.enabled) }"
                matInput formControlName="CumulationPreviousSituationAmountTaxExcluded" type="text" decimalFormat step="0.01">
            </div>
          </mat-form-field>
        </div>
        <div fxFlex="6" fxFlex.gt-sm="6" fxLayoutAlign="center" *ngIf="isAmountHTDifferent">
          <div class="errorHT">
            <mat-icon class="errorHT" matTooltip="Attention : les 2 montants sont différents, veuillez vérifier les données saisies.">
              report_problem</mat-icon>
          </div>
        </div>
        <div fxFlex="14" fxFlex.gt-sm="14">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>MONTANT HT </mat-label>
            <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.AmountTaxExcluded.dirty, formControls.AmountTaxExcluded.enabled) }" matInput formControlName="AmountTaxExcluded" type="text"
              decimalFormat pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01" (change)="setSumInvoice()">
          </mat-form-field>
        </div>
        <div fxFlex="14" fxFlex.gt-sm="14">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>MONTANT TVA </mat-label>
            <input matInput value="{{this.invoiceDetailAmountCalc.marketAndAmendmentsVAT}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
              [style]="commonLibrary.getSumClass()">
          </mat-form-field>
        </div>
        <div fxFlex="14" fxFlex.gt-sm="14">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
            <mat-label>MONTANT TTC </mat-label>
            <input matInput value="{{this.invoiceDetailAmountCalc.marketAndAmendmentsTaxIncluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
              [style]="commonLibrary.getSumClass()">
          </mat-form-field>
        </div>
        <div fxFlex="2">
        </div>
      </div>
    </ng-template>

    <ng-template #InvoiceTemplateSituationFinalControl>
      <div fxLayout="row" class="no-wrapper">
        <div fxFlex="38" fxLayoutAlign="start center" fxLayoutGap="10px">
          <h2>TOTAL DES PAIEMENTS</h2>
        </div>
        <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutAlign="center" fxLayoutGap="10px">
          <div class="error" *ngIf="isAmountDifferent">
            <mat-icon class="error" matTooltip="Attention : les 2 montants sont différents, veuillez vérifier les données saisies.">
              report_problem</mat-icon>
          </div>
        </div>
        <div fxFlex="40" fxLayoutGap="10px">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
            <mat-label>SOMME SITUATION TTC</mat-label>
            <input matInput value="{{invoiceSumTaxIncluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled [style]="commonLibrary.getSumClass()">
          </mat-form-field>
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
            <mat-label>MONTANT TTC </mat-label>
            <input [ngStyle]="{'color': getColorDirtyOrNot(formControls.AmountTaxIncluded.dirty, formControls.AmountTaxIncluded.enabled) }" matInput formControlName="AmountTaxIncluded" type="text"
              decimalFormat pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01">
          </mat-form-field>
        </div>
        <div fxFlex="2" fxFlex.gt-sm="2" fxLayoutGap="10px">
        </div>
      </div>
    </ng-template>

  </form>
  <div class="bottom-bar">
    <app-invoice-detail-actions [(invoice)]="invoiceDetailModel" [invoiceViewType]="invoiceViewType" [invoiceForm]="invoiceDetailForm" [invoiceFormHasFiles]="hasFiles"
      [invoiceFormFile]="invoiceFormFile" [invoiceFormSelectedRecipientEntity]="selectedRecipientEntityId" [invoiceFormSelectedAsset]="selectedAssetReference" [postActionCallBack]="postActionCallBack"
      [canCancelProcess]="invoiceParams.canCancelProcess" [canManageInvoiceAGI]="invoiceParams.canManageInvoiceAGI" [isInvoiceFormUpdated]="isFormUpdated"
      [hasMandatoryFieldChanged]="hasMandatoryFieldChanged" [primaryReferenceHasChanged]="primaryReferenceHasChanged" [injection]="injection" [canWaitInvoice]="CanWaitInvoice"
      [canProcessInvoice]="CanProcessInvoice">
    </app-invoice-detail-actions>
  </div>
</div>